import { render, staticRenderFns } from "./KpiModuleStyle.vue?vue&type=template&id=c51da2a0"
import script from "./KpiModuleStyle.vue?vue&type=script&lang=js"
export * from "./KpiModuleStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports